import { resolveCountry } from "./FormatByCountry";

const formatDecimal2Digits = (value: string) => {
  const country = resolveCountry();
  if (country === "MY") {
    return value
      .replace(/,/g, "")       // strip commas (could be thousands)
      .replace(/[^\d.]/g, "")  // keep digits and dot only
      .replace(/(\..*?)\./g, "$1")  // allow only one dot
      .replace(/^(\d*\.?\d{0,2}).*$/, "$1"); // max 2 digits after dot
  }
  // ID: desimal koma, 2 digit
  return value
    .replace(/\./g, ",")
    .replace(/[^\d,]/g, "")
    .replace(/(,.*?),/g, "$1")
    .replace(/^(\d*,?\d{0,2}).*$/, "$1");
};

export default formatDecimal2Digits;
